type Modal = {
  element: { modal: () => void };
  close: Promise<unknown>;
};

type TermsDialogDependencies = {
  showModal: (options: unknown) => Promise<Modal>;
  logError?: (error: unknown) => void;
};

export type TermsDialogOptions = {
  mode?: 'payg' | 'membership' | string;
  context?: Record<string, any>;
};

export function buildWaiverData(mode: string | undefined, context: Record<string, any>) {
  if (mode === 'payg') {
    return { waiverType: 'PAYGPAYMENT' };
  }
  if (mode !== 'membership') {
    return null;
  }

  const data: Record<string, unknown> = {
    waiverType: 'MEMBERSHIP',
    membershipName: context.membershipName,
    membershipPlan: context.membershipPlan,
    firstName: context.firstName,
    lastName: context.lastName,
    email: context.email,
    frequency: context.frequency,
    joiningFee: context.joiningFee,
    price: context.price,
  };
  if (context.isCreditPack !== undefined) {
    data.isCreditPack = context.isCreditPack;
  }
  if (context.notDismissable) {
    data.notDismissable = true;
  }
  return data;
}

export function createTermsDialogService(dependencies: TermsDialogDependencies) {
  function open(options: TermsDialogOptions = {}) {
    const context = options.context || {};
    const data = buildWaiverData(options.mode, context);
    if (!data) {
      return undefined;
    }

    return dependencies
      .showModal({
        templateUrl: 'dialogs/waivers/waivers.html',
        controller: 'WaiversController',
        controllerAs: 'vm',
        inputs: {
          data,
          buttonAction: context.buttonAction !== undefined ? context.buttonAction : false,
        },
      })
      .then((modal) => {
        modal.element.modal();
        modal.close.then(
          typeof context.onClose === 'function' ? context.onClose : () => undefined
        );
        return modal;
      })
      .catch((error) => {
        dependencies.logError?.(error);
        return undefined;
      });
  }

  return { open };
}
